export default __webpack_public_path__ + "static/media/check.a9b72752.svg";